
import { defineComponent } from 'vue'
import { mapGetters, mapState } from 'vuex'

import AsahiButton from '@/components/library/AsahiButton.vue'
import AsahiTypography from '@/components/library/Typography.vue'
import formatDateMixin from '@/utils/mixin'
import remove from '@/components/library/assets/remove.svg'
import { BasketMutationTypes } from '@/store/modules/basket/interfaces/mutation-types'
import { CatalogActionType } from '@/store/modules/catalog/interfaces/action-type'
import { CatalogMutationType } from '@/store/modules/catalog/interfaces/mutation-type'

const STARTING_PAGE_SIZE = 24

const CATALOG_PAGE_SIZE = 1000

export default defineComponent({
  name: 'PLNModal',
  components: {
    AsahiTypography,
    AsahiButton
  },
  mixins: [formatDateMixin],
  props: {
    closeModal: {
      type: Function,
      default: () => {
        /* */
      }
    },
    isOnTradeCustomer: {
      type: Boolean,
      default: false

    }
  },
  data () {
    return {
      remove,
      loading: false,
      pageSize: STARTING_PAGE_SIZE
    }
  },
  computed: {
    ...mapState('basket', ['id', 'query', 'items']),
    ...mapState('catalog', ['productFreeBeer']),

    sku () {
      return this.$route?.params?.id as string
    },
    queries () {
      return this.$store.state.catalog.queries
    },
    allProductAdded () {
      return !(this.productFreeBeer.some((item : any) => item.item_id === '0'))
    },
    productAvailable () {
      const productData = this.productFreeBeer.filter((item : any) => item.item_id === '0')
      return productData ? productData.length : 0
    },
    productAdded () {
      const productData = this.productFreeBeer.filter((item : any) => item.item_id !== '0')
      return productData ? productData.length : 0
    },
    isAllProductAdded () {
      if (this.productFreeBeer && this.productFreeBeer.length === this.productAdded) {
        return true
      }
      return false
    }

  },
  created () {
    this.getBeerProducts('')
  },
  methods: {

    async setFreeBeerProduct (item : any, type: string) {
      this.loading = true
      if (type === 'addtocart') {
        await this.$store.dispatch(
          'catalog/FETCH_ADD_FREE_BEER_PRODUCT',
          {
            id: item.id,
            qty: item.qty,
            product_id: item?.product_id,
            operate_flag: type
          }, { root: true })
      } else if (type === 'remove') {
        await this.$store.dispatch(
          'catalog/FETCH_REMOVE_FREE_BEER_PRODUCT',
          {
            item_id: item.item_id,
            id: item.id,
            product_id: item?.product_id,
            operate_flag: type
          }, { root: true })
      }
      await this.getBeerProducts(type)
      this.loading = false
    },
    async getBeerProducts (type : string) {
      this.loading = true
      if (this.$route.name !== 'quickorder') {
        await this.$store.dispatch(
          'catalog/FETCH_FREEBEER_PRODUCT',
          {
            cartId: this.id

          },
          { root: true }
        )
      }
      if (this.$route.name === 'favorites') {
        await this.$store.dispatch('catalog/FETCH_FAVORITES', this.queries, { root: true })
      }
      this.$store.commit(BasketMutationTypes.SET_LOADING, true)
      await this.$store.dispatch('basket/FETCH_CART_QUERY', { cart_id: this.id }, { root: true })
      this.$store.commit(CatalogMutationType.SET_LOADING, false)
      if (type) {
        if (this.$route.name === 'productsDetail') {
          const payload = { sku: this.sku }
          await this.$store.dispatch('catalog/FETCH_PRODUCT', payload, { root: true })
        } else if (this.$route.name === 'specialoffer') {
          await this.$store.dispatch('catalog/FETCH_SPECIAL_OFFERS', this.queries, { root: true })
        } else if (this.$route.name === 'homepage') {
          await this.fetchLowStockProduct()
        } else {
          await this.bufferedFetchProduct()
        }
      }
      this.loading = false
    },

    async bufferedFetchProduct () {
      if (Object.values(this.queries).findIndex(value => value?.length > 0) < 0) {
        this.pageSize = STARTING_PAGE_SIZE
      }
      await this.$store.dispatch('catalog/FETCH_PRODUCTS', { ...this.queries, pageSize: this.pageSize }, { root: true })
      if (this.pageSize !== CATALOG_PAGE_SIZE) {
        this.pageSize = CATALOG_PAGE_SIZE
        await this.$store.dispatch('catalog/FETCH_PRODUCTS', { ...this.queries, pageSize: this.pageSize, bypassLoading: true }, { root: true })
      }
    },
    fetchLowStockProduct () {
      const lowStockQueries = this.isOnTradeCustomer
        ? {
            sort: { brand: 'ASC' },
            pageSize: 50,
            is_peroni: false,
            currentPage: 1,
            material_type: 'GLASSWARE'
          }
        : {
            sort: { brand: 'ASC' },
            pageSize: 10,
            is_peroni: false,
            currentPage: 1,
            product_lowstock: 1
          }

      this.$store.dispatch('catalog/FETCH_LOW_STOCK_PRODUCTS', lowStockQueries, { root: true })
    }

  }
})
